import { apiUrl } from './env';

async function parseJSON(response) {
  if (!response.ok && !response.body) {
    return null;
  }

  if (response.status === 204 || response.status === 205) {
    return true;
  }

  const json = await response.json();
  json.meta = response;

  return json;
}

export default async function request(url, token, options = {}) {
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  }).then(parseJSON);
}

export async function fetcher(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(parseJSON)
    .then(res => {
      if (res.data) return res.data;

      throw res.error || res.message;
    })
    .catch(error => {
      if (error?.error) {
        throw error.error;
      }

      if (error?.message) {
        throw error.message;
      }

      throw new Error(error ?? 'Unknown Error');
    });
}

export async function suspenseFetcher(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(async response => {
      if (!response.ok && !response.body) {
        return null;
      }

      if (response.status === 204 || response.status === 205) {
        return true;
      }

      const json = await response.json();

      return json;
    })
    .then(res => {
      if (res.data) return res.data;

      return res;
    });
}
